import { useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import ChatComponent from '../component/imageViewer/helper/ChatComponent'

const Chat = () => {
    const { imageId } = useParams()
    if (imageId) return (
        <Box className="p-3 w-100 h-100">
            <ChatComponent imageId={Number(imageId)} />
        </Box>
    )
    else return <Typography>Image ID not found</Typography>
}

export default Chat